import {OverlayContainer} from '@angular/cdk/overlay';
import {Injectable} from '@angular/core';

@Injectable()
export class FullScreenOverlayContainer extends OverlayContainer {
    public toggle(): void {
        console.log('Toggled container');
    }
}
